// src/store/services/GestionesAtrasadasSegunEvento.js
import feathersClient, {
    makeServicePlugin,
    BaseModel,
  } from '../../feathers-client';
  
  class GestionesAtrasadasSegunEvento extends BaseModel {
    constructor(data, options) {
      super(data, options);
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'GestionesAtrasadasSegunEvento';
    // Define default properties here
    static instanceDefaults() {
      return {};
    }
  }
  const servicePath = 'gestiones-atrasadas-segun-evento';
  const servicePlugin = makeServicePlugin({
    namespaced: true,
    namespace: 'GestionesAtrasadasSegunEvento',
    Model: GestionesAtrasadasSegunEvento,
    service: feathersClient.service(servicePath),
    servicePath,
  });
  
  // Setup the client-side Feathers hooks.
  feathersClient.service(servicePath).hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    after: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
  });
  
  export default servicePlugin;
  